var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-wrapper auth-v1"},[_c('v-btn',{attrs:{"color":"secondary"},on:{"click":_vm.onFinishedPayment}},[_vm._v(" Payment successful ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }